import { render, staticRenderFns } from "./_general.vue?vue&type=template&id=1b8ac2fa&"
import script from "./_general.vue?vue&type=script&lang=js&"
export * from "./_general.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports